import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

// Keep in sync with request_fulfillment.py
// There is additional status here PENDING that is used for aggregated values but
// is never persisted in a RequestFulfillment
export enum FulfillmentStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

// Keep in sync with FULFILLMENT_STATUS_NAMES in benchling/requests/models/request_fulfillment.py
export const FULFILLMENT_STATUS_NAMES = {
  [FulfillmentStatus.PENDING]: 'Pending',
  [FulfillmentStatus.IN_PROGRESS]: 'In progress',
  [FulfillmentStatus.COMPLETED]: 'Completed',
  [FulfillmentStatus.FAILED]: 'Marked for redo',
};

export const FULFILLMENT_STATUS_ICONS: Record<
  FulfillmentStatus,
  {className: string; icon: BenchlingIconName}
> = {
  [FulfillmentStatus.PENDING]: {
    className: 'requestFulfillment-icon--pending',
    icon: 'request-pending',
  },
  [FulfillmentStatus.IN_PROGRESS]: {
    className: 'requestFulfillment-icon--in-progress',
    icon: 'request-in-progress',
  },
  [FulfillmentStatus.COMPLETED]: {
    className: 'requestFulfillment-icon--completed',
    icon: 'request-executed',
  },
  [FulfillmentStatus.FAILED]: {
    className: 'requestFulfillment-icon--pending',
    icon: 'request-pending',
  },
};

interface RequestFulfillmentBase {
  requestId: string;
  requestTaskId: string | null;
  sampleGroupId: string | null;
  entryId?: string | null;
  workflowId?: string | null;
}

export interface RequestFulfillment extends RequestFulfillmentBase {
  id: string;
  createdAt: string;
  status: FulfillmentStatus;
  statusAfterReview: FulfillmentStatus;
}
export interface RequestFulfillmentUpdate {
  fulfillmentId: string;
  status: FulfillmentStatus;
}

// Shape of request fulfillment that is received from the server

export interface RequestFulfillmentDefinition extends RequestFulfillmentBase {
  cid: string;
}

// Shape of the request fulfillment that is created on the client before it is persisted on the server

export interface RequestSampleStatusCounts {
  [FulfillmentStatus.PENDING]: number;
  [FulfillmentStatus.IN_PROGRESS]: number;
  [FulfillmentStatus.COMPLETED]: number;
  [FulfillmentStatus.FAILED]: number;
}
